// extracted by mini-css-extract-plugin
export default {"article":"chXsVkG","padding":"x5a89uW"};